module.exports = ngAria;


/*****************
 ** WEBPACK FOOTER
 ** external "ngAria"
 ** module id = 174
 ** module chunks = 0
 **/